// extracted by mini-css-extract-plugin
export default {"p":"SSO_p__+I6RW"};